<template>
  <div v-if="modelValue" class="video-modal" @click.self="close">
    <div class="video-modal__content">
      <button class="video-modal__close" @click="close">&times;</button>
      <video
        ref="videoPlayer"
        class="video-modal__player"
        controls
        autoplay
        playsinline
        preload="auto"
        :poster="poster"
      >
        <source :src="src" type="video/mp4" />
      </video>
    </div>
  </div>
</template>
  
<script setup>
import { ref, watch, nextTick, onUnmounted } from 'vue'

const props = defineProps({
  modelValue: Boolean,
  src: { type: String, required: true },
  poster: { type: String, default: '' }
})
const emit = defineEmits(['update:modelValue'])

const videoPlayer = ref(null)

const close = () => {
  if (videoPlayer.value) {
    videoPlayer.value.pause()
    videoPlayer.value.currentTime = 0
  }
  emit('update:modelValue', false)
  document.body.style.overflow = ''
}

watch(() => props.modelValue, async (val) => {
  if (val) {
    document.body.style.overflow = 'hidden'
    await nextTick()
    if (videoPlayer.value) {
      videoPlayer.value.currentTime = 0
      videoPlayer.value.muted = true 
      videoPlayer.value.play()
    }
  } else {
    close()
  }
})

</script>
  
  <style lang="scss" scoped>
  @import "@/assets/scss/app";

  .video-modal {
    position: fixed;
    z-index: 9999;
    inset: 0;
    background: rgba($black, 0.85);
    display: flex;
    align-items: center;
    justify-content: center;

      .video-modal__content {
          position: relative;
          border-radius: 20px;
          padding-top: 3rem;
          max-width: 95vw;
          max-height: 80vh;
          display: flex;
          flex-direction: column;
          align-items: center;
      }
      .video-modal__close {
        position: absolute;
        top: 0;
        right: 0;
        color: $white;
        background: rgba($green, 0.70);
        border: none;
        font-size: 2rem;
        cursor: pointer;
        z-index: 2;
        border-radius: 50%;
        width: 40px;
        height: 40px;
        line-height: 36px;
        text-align: center;
      }
      .video-modal__player {
        width: 70vw;
        max-width: 800px;
        max-height: 60vh;
        background: $black;
        border-radius: 20px;
        outline: none;
      }
      @media (max-width: 768px) {
      .video-modal__player {
          width: 95vw;
          max-width: 100vw;
          max-height: 40vh;
      }
    }
}
  </style>